import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import {
  IBriefLedgersSearchRequest,
  IGetBriefLedgers,
} from "@shared/lib/types/briefLedger";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_LEDGER_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useGetBriefsLedgers(params: IBriefLedgersSearchRequest) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IGetBriefLedgers>
  >({
    queryKey: [...BRIEF_LEDGER_QUERY_KEY, params],
    queryFn: () => BriefService.getBriefsLedgers(params),
    enabled: !!params.briefIds?.length,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    ledgers: data?.data?.data || [],
    totalCount: data?.data?.pagination.totalCount || 0,
    isFetching: isLoading,
    isError,
  };
}
